import { z } from 'zod';

export const NavigationEntrySchema = z.object({
  id: z.string(),
  projectId: z.string(),
  projectName: z.string(),
  pageId: z.string(),
  pageName: z.string(),
  timestamp: z.number(),
  parameters: z.record(z.string(), z.unknown()).optional(),
  scrollPosition: z.object({ x: z.number(), y: z.number() }).optional(),
});

export const ProjectPageInfoSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const AccessibleProjectInfoSchema = z.object({
  name: z.string(),
  organizationId: z.string().optional(),
  organizationName: z.string().optional(),
  pages: z.array(ProjectPageInfoSchema).optional(),
});

export const ContentSlotSchema = z.object({
  containerId: z.string(),
  activeContentId: z.string(),
  availableContentIds: z.array(z.string()),
});

export const SerializedNavigationStateSchema = z.object({
  history: z.array(NavigationEntrySchema),
  currentIndex: z.number(),
  maxHistoryLength: z.number(),
  accessibleProjects: z.array(z.tuple([z.string(), AccessibleProjectInfoSchema])),
  lastProjectsFetch: z.number(),
  contentSlots: z.array(z.tuple([z.string(), ContentSlotSchema])),
});

export type NavigationEntry = z.infer<typeof NavigationEntrySchema>;
export type AccessibleProjectInfo = z.infer<typeof AccessibleProjectInfoSchema>;
export type ContentSlot = z.infer<typeof ContentSlotSchema>;
export type SerializedNavigationState = z.infer<typeof SerializedNavigationStateSchema>;
